import "../styles/remote-store-details.css";
import React, { useState, useEffect } from "react";
import { Skeleton } from "primereact/skeleton";
import { PrimeIcons } from "primereact/api";
import { Carousel } from "primereact/carousel";
import { getToken } from "../utils/utility";
import ServiceController from "../services/service-controller";
import UserController from "../services/user-controller";

export default function RemoteStoreDetails(props) {
    const serviceController = new ServiceController();
    const userController = new UserController();
    const [isLoading, setIsLoading] = useState(false);
    const [store, setStore] = useState({});
    const [isLogin, setIsLogin] = useState(false);

    const getData = async function () {
        try {
            setIsLoading(true);
            let code = "";
            if (window.location.href.indexOf("?") > 0) {
                let urlParams = new URLSearchParams(window.location.href.split("?")[1]);
                code = urlParams.get("code");
            }
            const storeResult = await serviceController.getRemoteStore(code);
            if (storeResult.isSuccess === false) throw storeResult.message;
            setStore(storeResult.value);
        } catch (error) {
            alert(error.toString());
        }
        setIsLoading(false);
    };

    const imageTemplate = (image) => {
        return (
            <div className="banner">
                <img src={image.imageUrl} alt={"تصویر فروشگاه"} />
            </div>
        );
    };

    const autoLoginToUrl = async function (url) {
        try {
            setIsLoading(true);
            await userController.autoLogin(url)
        } catch (error) {
            alert(error.toString());
        }
        setIsLoading(false);
    }

    useEffect(() => {
        setIsLogin(getToken() != null);
        getData();
    }, []);

    return (
        <div>
            {isLoading === true && (
                <>
                    <div className="flex gap-4 mb-4">
                        <Skeleton height="15rem" className="w-3"></Skeleton>
                        <Skeleton height="15rem" className="w-3"></Skeleton>
                        <Skeleton height="15rem" className="w-3"></Skeleton>
                        <Skeleton height="15rem" className="w-3"></Skeleton>
                    </div>
                    <div className="flex gap-4 mb-4">
                        <Skeleton height="15rem" className="w-3"></Skeleton>
                        <Skeleton height="15rem" className="w-3"></Skeleton>
                        <Skeleton height="15rem" className="w-3"></Skeleton>
                        <Skeleton height="15rem" className="w-3"></Skeleton>
                    </div>
                    <div className="flex gap-4 mb-4">
                        <Skeleton height="15rem" className="w-3"></Skeleton>
                        <Skeleton height="15rem" className="w-3"></Skeleton>
                        <Skeleton height="15rem" className="w-3"></Skeleton>
                        <Skeleton height="15rem" className="w-3"></Skeleton>
                    </div>
                </>
            )}

            <div className="remote-store-details">
                <div>
                    <aside>
                        <Carousel
                            value={store.images}
                            numVisible={1}
                            numScroll={1}
                            itemTemplate={imageTemplate}
                            autoplayInterval={3000}
                            circular
                        />

                        <ol>
                            <li>
                                <a href={store.webSite} target="_blank" rel="noreferrer">
                                    <i className={PrimeIcons.GLOBE}></i>
                                </a>
                            </li>
                            <li>
                                <a href={store.telegram} target="_blank" rel="noreferrer">
                                    <i className={PrimeIcons.TELEGRAM}></i>
                                </a>
                            </li>
                            <li>
                                <a href={store.instagram} target="_blank" rel="noreferrer">
                                    <i className={PrimeIcons.INSTAGRAM}></i>
                                </a>
                            </li>
                        </ol>
                    </aside>
                    <section>
                        <h2>{store.name} </h2>
                        {store.videoUrl && (
                            <video controls>
                                <source src={store.videoUrl} type="video/mp4" />
                            </video>
                        )}
                        <h3>توضیحات تکمیلی</h3>
                        <p dangerouslySetInnerHTML={{ __html: store.notes }}></p>
                        <h3>آدرس</h3>
                        <p>{store.address}</p>

                        {isLogin === true ? (
                            <div className="buttons">
                                <a href={`tel:${store.tel}`}>تماس : {store.tel}</a>
                                <a
                                    className="request"
                                    href="/#"
                                    onClick={(e) => { e.preventDefault(); autoLoginToUrl(`https://offplus.ir/%DA%A9%D8%A7%D9%84%D8%A7%D9%87%D8%A7-%D9%88-%D8%AE%D8%AF%D9%85%D8%A7%D8%AA?store=${store.code}`) }}
                                >
                                    خرید محصولات / خدمات...
                                </a>
                            </div>
                        )
                            : (
                                <div className="buttons">
                                    <a href="/#/login">ورود جهت درخواست...</a>

                                </div>
                            )
                        }
                    </section>
                </div>
                <ul className="remote-products">
                    {store.products?.map((item) => (
                        <li>
                            {isLogin === true ? (
                                <a href="/#/1" onClick={(e) => { e.preventDefault(); autoLoginToUrl(`https://offplus.ir/product/${item.code}_${item.name.replace(/ /g, "-")}`) }} rel="noreferrer">
                                    <img src={item.imageUrl} alt="" />
                                    <h2>{item.name}</h2>
                                </a>
                            ) : (
                                <a href="/#/login" rel="noreferrer">
                                    <img src={item.imageUrl} alt="" />
                                    <h2>{item.name}</h2>
                                </a>)
                            }



                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}
